import React from "react";

function FlagFootballEvent() {
  return (
    <>
      <section className="flag-football-event">
        <div className="container">
          <div className="combat-feature-content">
            <h2 className="combat-feature-title futuraPTBold">
              Fast. Competitive. <br />Built for the Next Generation.
            </h2>

            <p className="combat-feature-text">
              UA Flag Football brings speed, skill, and nonstop
              action to the field at ADS Sports Complex. Designed
              to give young athletes an exciting way to compete,
              develop their game, and build confidence, our flag
              football experience combines high-energy league
              play with teamwork and sportsmanship. Whether they’re
              making the big catch, pulling a game-saving flag, or
              scoring the winning touchdown, every athlete gets a
              chance to be part of the action.
            </p>

            <a href="/events" className="btn combat-feature-button">
              BOOK YOUR FLAG FOOTBALL EVENT
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default FlagFootballEvent;
